<div class="modalities-menu">
  <div class="modalities-item buttonEl" *ngFor="let modality of this.config.modalities">
    <div class="buttonEl modality-svg div-container-element" id="{{ modality.name }}" *ngIf="!modality.active" [inlineSVG]="modality.icon" (click)="this.selectModality(modality)" title="turn on {{ modality.name }} feedback/control ({{ modality.accelerator }})"></div>
    <div class="buttonEl modality-svg div-container-element" id="{{ modality.name }}" *ngIf="modality.active" [inlineSVG]="modality.active_icon" (click)="this.selectModality(modality)" title="turn off {{ modality.name }} feedback/control ({{ modality.accelerator }})"></div>
  </div>
</div>
<div class="voice-input" *ngIf="this.voiceControl" [ngClass]="{ darkMode: this.config.theme === 'dark-mode' }">
  <div class="modality-svg modalities-item-speech-balloon" [ngClass]="{ darkMode: this.config.theme === 'dark-mode' }">
    <div [inlineSVG]="'/assets/images/voice-active.svg'" (click)="speak()"></div>
  </div>
  <div class="speech-balloon hideEarSide" id="speech-balloon" [ngClass]="{ darkMode: this.config.theme === 'dark-mode' }">
    <div id="speech-input">{{ this.speechData }}</div>
    <div id="speech-output" [ngClass]="{ darkMode: this.config.theme === 'dark-mode' }">{{ this.speechOutput }}</div>
    <!-- <input type="text" id="speech-ballon-input-field" x-webkit-speech /> -->
  </div>
  <div class="modality-svg modalities-item-speech-balloon" [ngClass]="{ darkMode: this.config.theme === 'dark-mode' }">
    <div class="listening" [inlineSVG]="'/assets/images/audio-active.svg'" (click)="activateSpeechRecognition()"></div>
  </div>
  <div class="voiceInputBars" id="audio-input">
    <div class="bar" id="bar1"></div>
    <div class="bar" id="bar2"></div>
    <div class="bar" id="bar3"></div>
    <div class="bar" id="bar4"></div>
    <div class="bar" id="bar5"></div>
  </div>
</div>

<audio id="audio-click" src="../../../assets/audio/subtle-click.wav"></audio>
<audio id="audio-slide" src="../../../assets/audio/door-slide.wav"></audio>
<audio id="audio-slide-click" src="../../../assets/audio/slide-click.wav"></audio>
<audio id="audio-gate-latch-click" src="../../../assets/audio/gate-latch-click.wav"></audio>
<audio id="audio-hard-click" src="../../../assets/audio/hard-click.wav"></audio>
<audio id="audio-on-off-light-switch" src="../../../assets/audio/on-or-off-light-switch-tap.wav"></audio>
<audio id="audio-lock-sound" src="../../../assets/audio/lock-sound.wav"></audio>
